// workbox
import { Workbox } from 'workbox-window';

if ('serviceWorker' in navigator) {
    const wb = new Workbox('/service-worker.js');
    wb.register();
}

// default
window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');
import WOW from 'wow.js';
new WOW().init();

// module
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import '../../../../js-modules/Debug';
window.ZoneObject = require('../../../../js-modules/ZoneObject').default;
require('../../../../js-modules/modalNotify');
require('../../../../js-modules/jquery.maskedinput');
require('../../../../js-modules/isMouseOver');
require('../../../../js-modules/ajax');
require('../../../../js-modules/scroller');
require('../../../../js-modules/label_up');
require('../../../../js-modules/validate');
require('../../../../js-modules/webp');
require('../../../../js-modules/items');
require('../../../../js-modules/Selection');
require('../../../../js-modules/text_count');
require('../../../../js-modules/modalVideoStop');
require('../../../../js-modules/URLParam');
require('../../../../js-modules/cookie_accept');
window.MeSelect = require('../../../../js-modules/Select').default;
import 'jquery-ui/ui/widgets/slider';

// block
require('./block/Header');
require('./block/form-control');
require('./block/opacity');
require('./block/plug');
require('./block/bodyIsSafari');
require('./block/search');

// Глобальные переменные
import UserClass from './class/User/User';

window.UserClass = UserClass;
window.User = new UserClass(user);